import { render } from "./RegForm.vue?vue&type=template&id=71c30190&scoped=true"
import script from "./RegForm.vue?vue&type=script&lang=js"
export * from "./RegForm.vue?vue&type=script&lang=js"

import "./RegForm.vue?vue&type=style&index=0&id=71c30190&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c30190"]])

export default __exports__